import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICredentialModel } from '../../models/account/account-models';
import { MainDataFactory } from '../../data/factory.mainDataFactory';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [/*AuthService*/MainDataFactory]
})
export class LoginComponent {
    public show: boolean = true;
    public userModel: ICredentialModel = <ICredentialModel>{
        userName: "",
        password: "",
        rememberMe: false,
        excludeNormal: false
    };
    constructor(private router: Router, private mainDataFactory: MainDataFactory) { }

    public login() {
        this.show = false;
        let that = this;
        this.mainDataFactory.AuthService.login(this.userModel).then(() => {
            //TODO: PUT THIS BACK this.$rootScope.$broadcast(this.appConfig.user_logged_in, { "user_logged_in": true });
            //this.$state.transitionTo("account.index", null, { reload: true });//it will do the reload which means refreshed the full view
            //this.router.navigate(['/account']);
            that.router.navigate(['/']);
            //TODO: PUT THIS BACK this.mainCoreFactory.FormDialogFactory.alert(`Welcome ${this.userModel.UserName}`, IToastrType.Info);
        }, () => {
            this.show = true;
        });
    }
}